import { render } from "./tab-personal-background.vue?vue&type=template&id=6bbab08e&scoped=true"
import script from "./tab-personal-background.vue?vue&type=script&lang=js"
export * from "./tab-personal-background.vue?vue&type=script&lang=js"

import "./tab-personal-background.vue?vue&type=style&index=0&id=6bbab08e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bbab08e"]])

export default __exports__